const filterByAttributes = (data, attributes) => {
    return data.filter((item) => {
        return Object.keys(attributes).every((filter) => {
            const attribute = item.AttributeJSON[filter]
            if (
                attribute && attributes[filter].Type === 'String' &&
                !(
                    attribute
                        .toLowerCase()
                        .indexOf(attributes[filter].Value.toLowerCase()) == -1
                )
            )
                return true
            if (attribute &&
                attributes[filter].Type === 'Number' &&
                Number(attributes[filter].Max) >= Number(attribute) &&
                Number(attributes[filter].Min) <= Number(attribute)
            )
                return true
            if (attribute &&
                attributes[filter].Type === 'Date' &&
                attributes[filter].MaxDate >=
                    new Date(attribute.slice(0, -2)) &&
                attributes[filter].MinDate <= new Date(attribute.slice(0, -2))
            )
                return true
            else {
                return false
            }
        })
    })
}

export default filterByAttributes
